const am = {
  draftCharge: "የቅድመ ክስ ሰነድ", // Draft Charge
  // tabs:
  all: "ሁሉም",
  pending: "በመጠባበቅ ላይ",
  underInvestigation: "በምርመራ ላይ",
  officeOfCouncilDecision: "የምክር ቤት ውሳኔ ቢሮ",
  submissionDate: "የማቅረብ ቀን",
  councilDecisionType: "የምክር ቤት ውሳኔ አይነት",
  decisionMeasureType: "የውሳኔ መርህ አይነት",
  councilDecisionSummary: "የምክር ቤት ውሳኔ ማጠቃለያ",
  councilDecisionFile: "የምክር ቤት ውሳኔ ፋይል",
  nextAppointmentDate: "የሚቀጥለው ቀጠሮ ቀን",
  councilOrder: "የምክር ቤት ትዕዛዝ",
  remainingDaysForAppeal: "ለአቤቱታ የቀሩት ቀናት",
  day: "ቀን",
  days: "ቀናት",
  pdf: "ፒዲኤፍ",
  underLitigation: "በችሎት ሂደት ላይ",
  closed: "ዝግ ተደርጓል",

  // table:
  accusedProsecutor: "የተከሰሰው ዐቃቤ ሕግ",
  assignedTo: "የተመደበው",
  appliedDate: "የተላከበት ቀን",
  status: "ሁኔታ",
  phoneNumber: "ስልክ ቁጥር",
  assign: "መመደብ",
  assigned: "ተመድቧል",
  action: "ተግባር",
  open: "ክፈት",

  // Complaint List:
  pageTitle: "የቅሬታ መቀበያ ጥያቄዎች",
  addNewComplaint: "አዲስ ቅሬታ መጨመር",
  tableTitle: "← የአገልግሎት ጥያቄ ሰንጠረዥ",

  // New Complaint:
  complaintFormTitle: "ቅሬታ",
  complaintFormSubtitle: "እባክዎን የሚከተሉትን ዝርዝሮች በጥንቃቄ ይሙሉ።",
  selectAccusedProsecutor: "የተከሰሰውን ዐቃቤ ሕግ ይምረጡ",
  searchAccusedProsecutor: "የተከሰሰውን ዐቃቤ ሕግ በስም ይፈልጉ",
  woreda: "ወረዳ",
  zone: "ዞን",
  accusedProsecutorPhone: "የተከሰሰው ዐቃቤ ሕግ ስልክ",
  gender: "ጾታ",
  jobStatus: "የስራ ሁኔታ",
  receptionDate: "የተቀበለበት ቀን",
  dateOfOffense: "የወንጀል የተፈጸመበት ቀን",
  disciplinaryOffenseType: "የዘርፍ ወንጀል አይነት",
  selectOffenseType: "የወንጀል አይነት ይምረጡ",
  offenseDescription: "የወንጀል መግለጫ",
  describeIncident: "ክስተቱን እዚህ ይግለጹ",
  addComplaint: "ቅሬታ ያክሉ",
  male: "ወንድ",
  female: "ሴት",
  submissionError: "የማስገባት ስህተት",
  successfullyCreated: "በተሳካ ሁኔታ ተፈጥሯል",
  successfullyConfirmed: "በተሳካ ሁኔታ ተረጋግጧል",
  graveOffenseError: "ከባድ የዘርፍ ወንጀል በ4 ዓመታት ውስጥ ሪፖርት ማድረግ አለበት።",
  mediumOffenseError: "መካከለኛ የዘርፍ ወንጀል በ3 ዓመታት ውስጥ ሪፖርት ማድረግ አለበት።",
  pityOffenseError: "ቀላል የዘርፍ ወንጀል በ2 ዓመታት ውስጥ ሪፖርት ማድረግ አለበት።",
  dateRequired: "ቀን ያስፈልጋል ወይም የማያገለግል ነው።",
  submitting: "በማስገባት ላይ",
  prosecutorOffenceRegion: "ዐቃቤ ሕግ ወንጀል የፈጸመበት",
  prosecutorOffenceZone: "ዐቃቤ ሕግ ወንጀል የፈጸመበት ዞን",
  prosecutorOffenceWoreda: "ዐቃቤ ሕግ ወንጀል የፈጸመበት ወረዳ",

  // Complaint Detail:
  complaintDetail: "የቅሬታ ዝርዝር",
  detailInformation: "ዝርዝር መረጃ",
  litigation: "ክስ",
  appeal: "አቤቱታ",
  uploadChargeDocument: "የክስ ሰነድ ያከል",
  sendToRegistrar: "ወደ ሪጀስትራር ላክ",
  sendToCouncilOffice: "ወደ ሱሚን ቢሮ ላክ",
  sendToCouncilHead: "ወደ ሱሚን አለቃ ላክ",
  sendToRegionalCouncilHead: "ወደ ክልል የምክር ቤት ቢሮ ኃላፊ ላክ",
  sendToZonalCouncilHead: "ወደ ዞን የምክር ቤት ቢሮ ኃላፊ ላክ",
  backToProsecutor: "ወደ ከሳሽ ተመልስ",
  backToCouncilOfficer: "ወደ ሱሚን ቢሮ ተመልስ",
  approvedToCreateLetter: "ደብዳቤ ለመፍጠር ተፈቅዷል",
  createASummon: "ጠራቂ ፍጠር",
  terminate: "ያቋርጡ",
  addInitialHearing: "የመጀመሪያ መስማት ያክሉ",
  addDailyHearing: "የቀን መስማት ያክሉ",
  addLitigationDecision: "የክስ ውሳኔ ያክሉ",
  addCouncilOfficeDecision: "የሱሚን ቢሮ ውሳኔ ያክሉ",
  createAccusedAppeal: "የተከሳሽ አቤቱታ ፍጠር",
  updateAppeal: "አቤቱታ አዘምን",
  requestForAppeal: "ለአቤቱታ ጠይቅ",
  sent: "ተልኳል",
  failedToLoadComplaint: "የቅሬታ መጫን አልተሳካም።",
  failedToLoadInvestigation: "የምርመራ መጫን አልተሳካም።",
  failedToLoadSummon: "የጠራቂ መጫን አልተሳካም።",
  failedToLoadLitigation: "የክስ መጫን አልተሳካም።",
  failedToLoadCouncilLitigation: "የሱሚን ክስ መጫን አልተሳካም።",
  failedToLoadAppeal: "የአቤቱታ መጫን አልተሳካም።",
  failedToLoadAccusedSummon: "የተከሳሽ ጠራቂ መጫን አልተሳካም።",
  investigationNotFound: "ምርመራ አልተገኘም!",
  offenseType: "የተጠየቀው ዓይነት",
  terminationReason: "የማቋረጫ ምክንያት",
  orderGivenBy: "ትእዛዝ የተሰጠው በ",
  terminationDoc: "የማቋረጫ ሰነድ",
  documentInformation: "የሰነድ መረጃ",
  receivedBy: "ተቀብሏል በ",
  registeredBy: "የተመዘገበው በ",
  decisionType: "የውሳኔ አይነት",
  decisionSummary: "የውሳኔ ማጠቃለያ",
  evidenceInfo: "የማስረጃ መረጃ",
  assignedDate: "የተመደበበት ቀን",
  publicProsecutorDecision: "Public Prosecutor Decision",
  unassigned: "Unassigned",
  reassignCase: "Reassign Case",
  prosecutorDecision: "Prosecutor Decision",
  noDate: "No date",
  furtherInvestigation: "Further Investigation",
  prosecutorDecisionSummary: "የከሳሽ ውሳኔ ማጠቃለያ",
  prosecutorDecisionDocument: "የከሳሽ ውሳኔ ሰነድ",
  feedbackType: "የአስተያየት አይነት",
  hideFeedbacks: "አስተያየቶችን ደብቅ",
  showAllFeedbacks: "ሁሉንም አስተያየቶች አሳይ",
  chargeDocument: "የክስ ሰነድ",
  registeredDate: "የተመዘገበበት ቀን",
  registeredNumber: "የተመዘገበበት ቁጥር",
  chargeSummary: "የክስ ማጠቃለያ",
  articleOfCharge: "የክስ አንቀጽ",
  chargeDoc: "የክስ ሰነድ",
  chargeFeedback: "የክስ አስተያየት",
  councilChargeFeedback: "የሱሚን ክስ አስተያየት",
  addFeedback: "አስተያየት አክል",
  addFurtherInvestigation: "ተጨማሪ ምርመራ አክል",
  addRegistrationNo: "የመዝገብ ቁጥር አክል",
  updateChargeDoc: "የክስ ሰነድ አዘምን",
  addDecision: "ውሳኔ አክል",

  summon: "ጠራቂ",
  hearingDate: "የመስማት ቀን",
  addressInformation: "የአድራሻ መረጃ",
  summary: "ማጠቃለያ",
  summonDoc: "የጠራቂ ሰነድ",
  confirm: "አረጋግጥ",
  accusedProsecutorResponse: "የተከሳሽ ከሳሽ ምላሽ",
  letterDoc: "ደብዳቤ ሰነድ",
  addResponse: "ምላሽ አክል",

  dailyReportSummary: "የቀን ሪፖርት ማጠቃለያ",
  appointmentReason: "የቀጠሮ ምክንያት",
  attendances: "ተሳታፊዎች",
  member: "አባል",
  present: "ተገኝቷል",
  wasPresent: "ተገኝቷል",
  yes: "አዎ",
  no: "አይ",
  date: "ቀን",
  remark: "ማስታወሻ",
  minuteFile: "የሰአት ሰነድ",
  terminationFile: "የማቋረጫ ሰነድ",
  addAttendance: "ተሳታፊነት አክል",
  prosecutorOpinionOnDecision: "በውሳኔ ላይ የከሳሽ አስተያየት",
  feedback: "አስተያየት",
  prosecutorOpinion: "የከሳሽ አስተያየት",

  memorandumSummary: "የቅጣት አቤቱታ ማጠቃለያ",
  memorandumDoc: "የቅጣት አቤቱታ ሰነድ",
  appealType: "የአቤቱታ አይነት",
  feedbackOnMemorandum: "በማስታወሻ ላይ አስተያየት",
  addFeedbackOnMemorandum: "በማስታወሻ ላይ አስተያየት አክል",

  activityLogs: "የእንቅስቃሴ መዝገቦች",
  changedBy: "የለውጠው",
  actionType: "የተወሰነው እሴት አይነት",
  fieldName: "የተለዋዋጭ ስም",
  oldValue: "የቀድሞ እሴት",
  newValue: "አዲስ እሴት",
  additionalInfo: "ተጨማሪ መረጃ",
  modelName: "የሞዴል ስም",

  // Additions start
  successfullyUpdated: "በተሳካ ሁኔታ ተዘምኗል",
  appealRequest: "የይግባኝ ጥያቄ",
  decisionDay: "የውሳኔ ቀን",
  applicationNumber: "የማመልከቻ ቁጥር",
  accusedComplaintRequests: "የተከሳሽ ቅሬታ ጥያቄዎች",
  serviceRequestTable: "← የአገልግሎት ጥያቄ ሰንጠረዥ",
  appealToGeneralCouncil: "ለጠቅላላ ምክር ቤት የሚቀርብ ይግባኝ",
  generalCouncilLitigation: "የጠቅላላ ምክር ቤት ክርክር",
  accusedComplaintDetail: "የተከሳሽ ቅሬታ ዝርዝር",
  sendToCouncil: "ወደ ምክር ቤት ላክ",
  addAppealLitigationDecision: "የይግባኝ ክርክር ውሳኔ ያክሉ",
  appealToCourt: "ለፍርድ ቤት የሚቀርብ ይግባኝ",
  summonNotFound: "መጥሪያ አልተገኘም!",
  appealToCouncil: "ለምክር ቤት የሚቀርብ ይግባኝ",
  councilLitigation: "የምክር ቤት ክርክር",
  accusedSummon: "የተከሳሽ መጥሪያ",
  registrationNumber: "የምዝገባ ቁጥር",
  registrationDate: "የምዝገባ ቀን",
  claimSummary: "የክስ ማጠቃለያ",
  claimSummaryDoc: "የክስ ማጠቃለያ ሰነድ",
  letterUpload: "ደብዳቤ መጫኛ",
  responseSummary: "የምላሽ ማጠቃለያ",
  assignProsecutor: "ዐቃቤ ሕግ መድብ",
  confirmed: "ተረጋግጧል",
  confirmAccusedSummon: "የተከሳሽ መጥሪያን አረጋግጥ",
  selectProsecutor: "ዐቃቤ ሕግ ይምረጡ",
  cannotFindSummon: "መጥሪያውን ማግኘት አልተቻለም",
  canNotFindSummonOrAppealData: "የመጥሪያ ወይም የይግባኝ መረጃ ማግኘት አልተቻለም",
  noPermissionCreateDailyHearing: "የቀን ቀጠሮ ለመፍጠር ፈቃድ የለዎትም",
  addAccusedAppealDailyHearing: "የተከሳሽ ይግባኝ የቀን ቀጠሮ ያክሉ",
  datePlaceholder: "ምሳሌ፡ ሰኔ 12 ቀን 2014",
  givenOrder: "የተሰጠ ትዕዛዝ",
  detailsPlaceholder: "ዝርዝሩን እዚህ ያስገቡ...",
  uploadFiles: "ፋይሎችን ይጫኑ",
  addSummonRegistrationNo: "የመጥሪያ ምዝገባ ቁጥር ያክሉ",
  registrationNo: "የምዝገባ ቁጥር",
  registrationPlaceholder: "ምሳሌ፡ XX000001",
  submit: "አስገባ",
  accusedSummonNotFound: "የተከሳሽ መጥሪያ አልተገኘም!",
  responseFile: "የምላሽ ፋይል",
  complaintNotFound: "ቅሬታው አልተገኘም!",
  courtName: "የፍርድ ቤቱ ስም",
  courtNumber: "የፍርድ ቤት ቁጥር",
  hearingCourt: "ችሎት የሚሰማበት ፍርድ ቤት",
  courtOrderSummon: "የፍርድ ቤት ትዕዛዝ መጥሪያ",
  courtSummonFile: "የፍርድ ቤት መጥሪያ ፋይል",
  accusedAdvocate: "የተከሳሽ ጠበቃ",
  licenseNumber: "የፈቃድ ቁጥር",
  emDash: "—",
  accusedAdvocateComplaintRequests: "የተከሳሽ ጠበቃ ቅሬታ ጥያቄዎች",
  accused: "ተከሳሽ",
  advocate: "ጠበቃ",
  paralegal: "ረዳት ጠበቃ",
  evidence: "ማስረጃ",
  reporter: "አመልካች",
  victim: "ተጎጂ",
  witness: "ምስክር",
  assignedProsecutor: "የተመደበ ዐቃቤ ሕግ",
  hearingInformation: "የችሎት መረጃ",
  noClaimSummaryAvailable: "ምንም የክስ ማጠቃለያ የለም",
  documents: "ሰነዶች",
  responseDocument: "የምላሽ ሰነድ",
  createSummon: "መጥሪያ ፍጠር",
  reassignProsecutor: "ዐቃቤ ሕግን እንደገና መድብ",
  previouslyAssignedProsecutor: "ቀደም ሲል ተመድቦ የነበረ ዐቃቤ ሕግ",
  name: "ስም",
  userId: "የተጠቃሚ መለያ",
  verbalLitigation: "የቃል ክርክር",
  evidenceInspection: "የማስረጃ ምርመራ",
  evidenceDefence: "የመከላከያ ማስረጃ",
  finalDecision: "የመጨረሻ ውሳኔ",
  createAccusedSummon: "የተከሳሽ መጥሪያ ፍጠር",
  hearingDatePlaceholder: "ምሳሌ፡ ሰኔ 12 ቀን 2014",
  detailsHere: "ዝርዝሩ እዚህ...",
  advocateAppealRequests: "የጠበቃ ይግባኝ ጥያቄዎች",
  councilAppeal: "የምክር ቤት ይግባኝ",
  councilAppealLitigation: "የምክር ቤት ይግባኝ ክርክር",
  courtAppeal: "የፍርድ ቤት ይግባኝ",
  courtAppealLitigation: "የፍርድ ቤት ይግባኝ ክርክር",
  appealDetail: "የይግባኝ ዝርዝር",
  rejectAppeal: "ይግባኝ ውድቅ አድርግ",
  createAppealSummon: "የይግባኝ መጥሪያ ፍጠር",
  appealNotFound: "ይግባኝ አልተገኘም!",
  forwardedToRegistrar: "ወደ ሬጅስትራር ተላልፏል",
  forwardedToCouncil: "ወደ ምክር ቤት ተላልፏል",
  generalCouncilAppeal: "የጠቅላላ ምክር ቤት ይግባኝ",
  generalCouncilAppealLitigation: "የጠቅላላ ምክር ቤት ይግባኝ ክርክር",
  createGeneralCouncilAppealSummon: "የጠቅላላ ምክር ቤት ይግባኝ መጥሪያ ፍጠር",
  addCouncilDecision: "የምክር ቤት ውሳኔ ያክሉ",
  councilDecisionDate: "የምክር ቤት ውሳኔ ቀን",
  egJune122014: "ምሳሌ፡ ሰኔ 12 ቀን 2014",
  selectDisciplineType: "የዲሲፕሊን ዓይነት ይምረጡ",
  addAppealDailyHearing: "የይግባኝ የቀን ቀጠሮ ያክሉ",
  dailyHearingHistory: "የቀን ቀጠሮ ታሪክ",
  noDailyHearingHistoryFound: "ምንም የቀን ቀጠሮ ታሪክ አልተገኘም!",
  youDoNotHavePermissionToCreateDailyHearing: "የቀን ቀጠሮ ለመፍጠር ፈቃድ የለዎትም",
  addCourtDecision: "የፍርድ ቤት ውሳኔ ያክሉ",
  prosecutorOpinionOnAppeal: "በይግባኝ ላይ የዐቃቤ ሕግ አስተያየት",
  courtDecisionDate: "የፍርድ ቤት ውሳኔ ቀን",
  courtDecisionType: "የፍርድ ቤት ውሳኔ ዓይነት",
  selectDisciplineMeasure: "የዲሲፕሊን እርምጃ ይምረጡ",
  courtDecisionFile: "የፍርድ ቤት ውሳኔ ፋይል",
  addAppealSummonDecision: "የይግባኝ መጥሪያ ውሳኔ ያክሉ",
  decisionFile: "የውሳኔ ፋይል",
  region: "ክልል",
  kebele: "ቀበሌ",
  summonFile: "የመጥሪያ ፋይል",
  addSummon: "መጥሪያ ያክሉ",
  uploadMemorandumOfDisciplinaryAppeal: "የዲሲፕሊን ይግባኝ መዝገበ ቃላት ይጫኑ",
  appealFromInspectionProsecutorToCouncilOffice:
    "ከኢንስፔክሽን ዐቃቤ ሕግ ወደ ምክር ቤት ቢሮ የሚቀርብ ይግባኝ",
  appealFromInspectionProsecutorToCourt: "ከኢንስፔክሽን ዐቃቤ ሕግ ወደ ፍርድ ቤት የሚቀርብ ይግባኝ",
  amendedMemorandumOfDisciplinaryAppealSummary: "የተሻሻለ የዲሲፕሊን ይግባኝ ማጠቃለያ",
  amendedMemorandumOfDisciplinaryAppealDoc: "የተሻሻለ የዲሲፕሊን ይግባኝ ሰነድ",
  uploadMemorandum: "ማስታወሻ ይጫኑ",
  compliantNotFound: "ቅሬታው አልተገኘም!",
  memorandumFileIsRequired: "የማስታወሻ ፋይል ያስፈልጋል",
  addChargeFeedback: "የክስ አስተያየት ያክሉ",
  expired: "ጊዜው ያለፈበት",
  ago: "ከዚህ በፊት",
  dueToday: "ዛሬ የሚያበቃ",
  dueTomorrow: "ነገ የሚያበቃ",
  remaining: "የቀረ",
  appealDecision: "የይግባኝ ውሳኔ",
  appealCouncilDecision: "የይግባኝ ምክር ቤት ውሳኔ",
  finalDecisionRendered: "በይግባኝ ምክር ቤት የተሰጠ የመጨረሻ ውሳኔ",
  decisionDate: "የውሳኔ ቀን",
  measureType: "የእርምጃ ዓይነት",
  appealDeadlineStatus: "የይግባኝ ቀነ-ገደብ ሁኔታ",
  deadline: "ቀነ-ገደብ",
  advocateClaimSummary: "የጠበቃ ክስ ማጠቃለያ",
  decisionDocuments: "የውሳኔ ሰነዶች",
  appealHearingSession: "የይግባኝ ሰሚ ችሎት",
  decisionMade: "ውሳኔ ተሰጥቷል",
  nextHearing: "የሚቀጥለው ቀጠሮ",
  hearingDecisionSummary: "የችሎት ውሳኔ ማጠቃለያ",
  hearingDocuments: "የችሎት ሰነዶች",
  officialDecisionDocument: "ይፋዊ የውሳኔ ሰነድ",
  caseTerminationDocument: "የመዝገብ መዝጊያ ሰነድ",
  noAppealLitigationData: "ምንም የይግባኝ ክርክር መረጃ የለም",
  noAppealLitigationMessage: "ለዚህ መዝገብ የሚገኝ ምንም የይግባኝ ውሳኔ ወይም የችሎት መዝገብ የለም።",
  accusedResponse: "የተከሳሽ ምላሽ",
  confirmAppealSummon: "የይግባኝ መጥሪያን አረጋግጥ",
  summonConfirmedBy: "መጥሪያው የተረጋገጠው በ",
  coordinator: "አስተባባሪ",
  rejectComment: "የውድቅ ማድረጊያ አስተያየት",
  showDailyHearingHistory: "የቀን ቀጠሮ ታሪክ አሳይ",
  institution: "ተቋም",
  noPermissionToTerminate: "ክርክሩን ለማቋረጥ ፈቃድ የለዎትም",
  terminateLitigation: "ክርክሩን አቋርጥ",
  advocateComplaintReceptionRequests: "የጠበቃ ቅሬታ መቀበያ ጥያቄዎች",
  failedToLoadAdvocates: "ጠበቃዎችን መጫን አልተሳካም።",
  failedToLoadDecisionTypes: "የውሳኔ ዓይነቶችን መጫን አልተሳካም",
  failedToLoadMeasureTypes: "የእርምጃ ዓይነቶችን መጫን አልተሳካም",
  receptionDateRequired: "የመቀበያ ቀን ያስፈልጋል።",
  offenseDateRequired: "ወንጀሉ የተፈጸመበት ቀን ያስፈልጋል።",
  accusedAdvocateRequired: "የተከሰሰው ጠበቃ ያስፈልጋል።",
  pettyOffenseError: "ቀላል የዲሲፕሊን ጥፋቶች ከተፈጸሙ በ2 ዓመት ውስጥ ሪፖርት መደረግ አለባቸው።",
  newAdvocateComplaintRegistration: "አዲስ የጠበቃ ቅሬታ ምዝገባ",
  officialFormDescription:
    "በሕግ ጠበቃዎች ላይ የዲሲፕሊን ቅሬታዎችን ለመመዝገብ የሚያገለግል ይፋዊ ቅጽ። ሁሉም ምልክት ያለባቸው ቦታዎች",
  areMandatory: "አስገዳጅ ናቸው",
  advocateInformation: "የጠበቃ መረጃ",
  advocateInformationDescription: "የተከሰሰውን ጠበቃ ይምረጡ እና የሙያ ዝርዝሮችን ያቅርቡ",
  accusedAdvocateDescription: "ቅሬታ የቀረበበትን የሕግ ጠበቃ ይለዩ",
  isAccusationReportByMobile: "ክሱ በሞባይል የቀረበ ነው?",
  accusationReportByMobileDescription: "ክሱ በሞባይል መተግበሪያ በኩል መቅረቡን ያረጋግጡ",
  reportApplicationNumber: "የሪፖርት ማመልከቻ ቁጥር",
  reportApplicationNumberDescription: "የሪፖርቱን ወይም የማመልከቻውን ዋቢ ቁጥር ያስገቡ",
  reportApplicationNumberPlaceholder: "ምሳሌ፡ APP-2024-00123",
  complaintType: "የቅሬታ ዓይነት",
  advocateComplaint: "የጠበቃ ቅሬታ",
  paralegalComplaint: "የረዳት ጠበቃ ቅሬታ",
  complaintTypeDescription: "ቅሬታው በጠበቃ ወይም በረዳት ጠበቃ ላይ መሆኑን ይምረጡ።",
  searchAdvocate: "ጠበቃ ፈልግ",
  searchAdvocateDescription: "ስም ወይም የፈቃድ ቁጥር ያስገቡ",
  searchAdvocatePlaceholder: "የጠበቃ ስም ወይም የፈቃድ ቁጥር ያስገቡ...",
  searchingAdvocateRegistry: "በጠበቆች መዝገብ ውስጥ በመፈለግ ላይ...",
  license: "ፈቃድ",
  na: "የማይመለከተው",
  noAdvocatesFound: "ተዛማጅ ጠበቃ አልተገኘም",
  legalAdvocate: "የሕግ ጠበቃ",
  phone: "ስልክ",
  caseDetails: "የመዝገብ ዝርዝሮች",
  caseDetailsDescription: "ስለ ቅሬታው እና ስለ ዲሲፕሊን ጥፋቱ የተሟላ ዝርዝር መረጃ ያቅርቡ",
  basicInformation: "መሰረታዊ መረጃ",
  selectClassification: "-- ምደባ ይምረጡ --",
  complaintReceptionDate: "ቅሬታው የተተቀበለበት ቀን",
  dateOfAllegedOffense: "ጥፋቱ ተፈጽሟል የተባለበት ቀን",
  fieldRequired: "ይህ ቦታ መሞላት አለበት",
  detailedOffenseDescription: "ዝርዝር የጥፋቱ መግለጫ",
  offenseDescriptionPlaceholder:
    "ስለ ተፈጸመው የዲሲፕሊን ጥፋት ዝርዝር መግለጫ ያስገቡ። ስለ ቀናት፣ ቦታዎች፣ ተሳታፊ ግለሰቦች እና ስለተጣሱ የሥነ-ምግባር ደንቦች ግልጽ ይሁኑ...",
  characters: "ፊደላት",
  returnToDashboard: "ወደ ዳሽቦርድ ተመለስ",
  clearAllFields: "ሁሉንም ቦታዎች አጽዳ",
  processingSubmission: "በማስገባት ላይ...",
  submitAdvocateComplaint: "የጠበቃ ቅሬታ አስገባ",
  issueASummon: "መጥሪያ አውጣ",
  reporters: "አመልካቾች",
  victims: "ተጎጂዎች",
  witnesses: "ምስክሮች",
  summonIssued: "መጥሪያ ወጥቷል",
  hide: "ደብቅ",
  show: "አሳይ",
  approved: "ጸድቋል",
  claimSummaryFile: "የክስ ማጠቃለያ ፋይል",
  addAccusedSummon: "የተከሳሽ መጥሪያ ያክሉ",
  addMemorandumFeedback: "የማስታወሻ አስተያየት ያክሉ",
  memorandumFileRequired: "የማስታወሻ ፋይል ያስፈልጋል",
  appealFromInspectionToCouncil: "ከኢንስፔክሽን ዐቃቤ ሕግ ወደ ምክር ቤት ቢሮ የሚቀርብ ይግባኝ",
  appealFromInspectionToCourt: "ከኢንስፔክሽን ዐቃቤ ሕግ ወደ ፍርድ ቤት የሚቀርብ ይግባኝ",
  memorandumDocument: "የዲሲፕሊን ይግባኝ ማስታወሻ ሰነድ",
  somethingWentWrong: "ችግር ተከስቷል።",
  addAppealRegistrationNo: "የይግባኝ ምዝገባ ቁጥር ያክሉ",
  provideChargeSummary: "እባክዎን የክስ ማጠቃለያ ያቅርቡ",
  provideArticleOfCharge: "እባክዎን የክስ አንቀጽ ያቅርቡ",
  chargeDocumentFramed: "የክስ ሰነድ በተሳካ ሁኔታ ተዘጋጅቷል",
  failedToFrameCharge: "የክስ ሰነድ ማዘጋጀት አልተሳካም",
  frameChargeDocument: "የክስ ሰነድ አዘጋጅ",
  framingCharges: "ክስ በማዘጋጀት ላይ",
  case: "መዝገብ",
  chargeSummaryPlaceholder: "ለሚዘጋጀው ክስ አጭር ማጠቃለያ...",
  articleOfChargePlaceholder: "ክስ የተመሰረተባቸው ሕጋዊ አንቀጾች እና ድንጋጌዎች...",
  clickToChange: "ለመቀየር ይጫኑ",
  clickToUploadOrDrag: "ለመጫን ይጫኑ ወይም ጎትተው ያስገቡ",
  fileTypes: "PDF, DOC, DOCX እስከ 10MB",
  removeFile: "ፋይሉን አስወግድ",
  cancel: "ሰርዝ",
  addChargeRegistrationNo: "የክስ ምዝገባ ቁጥር ያክሉ",
  prosecutorRequired: "ዐቃቤ ሕግ ያስፈልጋል",
  decisionCreated: "ውሳኔው በተሳካ ሁኔታ ተፈጥሯል",
  forwardToZone: "ወደ ዞን አስተላልፍ",
  selectZone: "ዞን ይምረጡ",
  decisionSummaryPlaceholder: "ስለ ውሳኔዎ ዝርዝር መረጃ ያቅርቡ...",
  processing: "በማከናወን ላይ...",
  summonInformationNotFound: "የመጥሪያ መረጃ አልተገኘም",
  dailyHearingOfficiallyDocumented: "የቀን ችሎት መዝገብ በይፋ ሰፍሯል",
  failedToDocumentDailyHearing: "የቀን ችሎት መመዝገብ አልተሳካም",
  inspectionOfficeDailyHearing: "የኢንስፔክሽን ቢሮ የቀን ችሎት",
  councilOfficeDailyHearing: "የምክር ቤት ቢሮ የቀን ችሎት",
  dailyHearingRecord: "የቀን ችሎት መዝገብ",
  hearingDetails: "የችሎት ዝርዝሮች",
  mustBeAfterTheHearingDate: "ከችሎት ቀን በኋላ መሆን አለበት",
  councilOrderInstruction: "የምክር ቤት ትዕዛዝ/መመሪያ",
  enterOfficialCouncilOrdersOrInstructions:
    "ይፋዊ የምክር ቤት ትዕዛዞችን ወይም መመሪያዎችን ያስገቡ...",
  selectAppointmentReason: "የቀጠሮ ምክንያት ይምረጡ",
  finalHearingDecisionWarning: "ይህ እንደ የመጨረሻ የችሎት ውሳኔ ይመዘገባል",
  provideOfficialSummaryOfTodayProceedings: "የዛሬውን ውሎ ይፋዊ ማጠቃለያ ያቅርቡ...",
  minuteDocumentation: "የቃለ-ጉባኤ ሰነድ",
  uploadMeetingMinutes: "የስብሰባ ቃለ-ጉባኤ ጫን",
  uploadOfficialMinutes: "ይፋዊ ቃለ-ጉባኤ ጫን",
  documentHearing: "ችሎቱን መዝግብ",
  dailyHearingRecordWillBeOfficiallyDocumented:
    "ይህ የችሎት መዝገብ በክርክር ሂደት ውስጥ በይፋ ይካተታል።",
  finalHearingDecisionConfirmation: "የመጨረሻ ችሎት ውሳኔ ማረጋገጫ",
  finalHearingDecisionConfirmationMessage:
    "ይህንን እንደ የመጨረሻ የችሎት ውሳኔ ሊመዘግቡት ነው። ይህ የክርክር ሂደቱን ያጠናቅቃል። ለመቀጠል እርግጠኛ ነዎት?",
  recordFinalDecision: "አዎ፣ የመጨረሻ ውሳኔ መዝግብ",
  goBack: "አይ፣ ተመለስ",
  prosecutorDecisionRegistry: "የዐቃቤ ሕግ ውሳኔ መዝገብ",
  decisionDetails: "የውሳኔ ዝርዝሮች",
  selectDecisionType: "የውሳኔ ዓይነት ይምረጡ",
  outOfJurisdictionForwardToZone: "ከስልጣን ውጪ በመሆኑ ወደ ዞን ተላልፏል",
  forwardedToZoneForFurtherInvestigation: "ለተጨማሪ ምርመራ ወደ ዞን ተላልፏል",
  selectZoneAdministration: "የዞን አስተዳደር ይምረጡ",
  caseWillBeTransferredToSelectedZonalAdministration:
    "መዝገቡ ወደ ተመረጠው የዞን አስተዳደር ይዛወራል",
  enterOfficialSummaryOfProsecutorDecision: "የዐቃቤ ሕግ ውሳኔ ይፋዊ ማጠቃለያ ያስገቡ...",
  uploadOfficialDecisionDocument: "ይፋዊ የውሳኔ ሰነድ ይጫኑ",
  uploadSupportingDocuments: "ደጋፊ ሰነዶችን ይጫኑ",
  fileTypesWithMax10mb: "PDF, DOC, JPG, PNG ፋይሎች (ከ10MB የማይበልጥ)",
  selectedDocuments: "የተመረጡ ሰነዶች",
  submitProsecutorDecision: "የዐቃቤ ሕግ ውሳኔ አስገባ",
  officialProsecutorialDeterminationNote: "ይህ ውሳኔ እንደ ይፋዊ የዐቃቤ ሕግ ውሳኔ ይመዘገባል።",
  prosecutorDecisionRecorded: "የዐቃቤ ሕግ ውሳኔ በይፋ ተመዝግቧል",
  failedToSubmitProsecutorDecision: "የዐቃቤ ሕግ ውሳኔ ማስገባት አልተሳካም",
  administrativeReviewDecision: "የአስተዳደር ክለሳ ውሳኔ",
  officialCaseManagementDetermination: "ይፋዊ የመዝገብ አስተዳደር ውሳኔ",
  administrativeDetermination: "የአስተዳደር ውሳኔ",
  selectAdministrativeDecision: "የአስተዳደር ውሳኔ ይምረጡ",
  nextCourseOfActionForCase: "ይህ በመዝገቡ ላይ የሚወሰደውን ቀጣይ እርምጃ ይወስናል",
  provideOfficialReasoningForAdministrativeDecision:
    "ለዚህ አስተዳደራዊ ውሳኔ ይፋዊ ምክንያቱን ያቅርቡ...",
  assignInvestigator: "መርማሪ መድብ",
  selectPublicProsecutor: "ዐቃቤ ሕግ ይምረጡ",
  assignedProsecutorWillConductOfficialInvestigation:
    "የተመደበው ዐቃቤ ሕግ ይፋዊ ምርመራውን ያከናውናል",
  cancelReview: "ክለሳውን ሰርዝ",
  processingDecision: "ውሳኔ በማከናወን ላይ...",
  investigatorAssignmentRequiredForApproval: "ለማጽደቅ መርማሪ መመደብ ያስፈልጋል",
  pleaseSelectZoneForForwarding: "እባክዎን ለማስተላለፍ ዞን ይምረጡ",
  decisionOfficiallyRecordedInSystem: "ውሳኔው በስርዓቱ ውስጥ በይፋ ተመዝግቧል",
  failedToProcessAdministrativeDecision: "የአስተዳደር ውሳኔውን ማከናወን አልተሳካም",
  forwardToZonalAdministration: "ወደ ዞን አስተዳደር አስተላልፍ",
  forwardToRegionalAdministration: "ወደ ክልል አስተዳደር አስተላልፍ",
  approveAndAssignInvestigator: "አጽድቅ እና መርማሪ መድብ",
  rejectComplaint: "ቅሬታውን ውድቅ አድርግ",
  requestAdditionalInformation: "ተጨማሪ መረጃ ጠይቅ",
  forwardToSelectedZone: "ወደ ተመረጠው ዞን አስተላልፍ",
  forwardToRegional: "ወደ ክልል አስተላልፍ",
  submitDecision: "ውሳኔ አስገባ",
  noPermissionToCreateDailyHearing: "የቀን ችሎት ለመፍጠር ፈቃድ የለዎትም",
  selectDecisionDate: "እባክዎን የውሳኔ ቀን ይምረጡ",
  provideDecisionSummary: "እባክዎን የውሳኔ ማጠቃለያ ያቅርቡ",
  decisionAddedSuccessfully: "የዐቃቤ ሕግ ውሳኔ በተሳካ ሁኔታ ተጨምሯል",
  failedToAddDecision: "የዐቃቤ ሕግ ውሳኔ ማከል አልተሳካም",
  addProsecutorDecision: "የዐቃቤ ሕግ ውሳኔ ያክሉ",
  characterCount: "የፊደላት ብዛት",
  chargeFile: "የክስ ፋይል",
  uploadDecisionDocuments: "የውሳኔ ሰነዶችን ይጫኑ",
  selectedFiles: "የተመረጡ ፋይሎች",
  clearAll: "ሁሉንም አጽዳ",
  supportingDocuments: "ደጋፊ ሰነዶች",
  optional: "አማራጭ",
  addingDecision: "ውሳኔ በመጨመር ላይ...",
  addEvidence: "ማስረጃ ያክሉ",
  collectedBy: "የሰበሰበው",
  collectedByPlaceholder: "ምሳሌ፡ አበበ ከበደ",
  evidenceType: "የማስረጃ ዓይነት",
  evidenceTypePlaceholder: "ምሳሌ፡ ሰነድ",
  collectionDate: "የተሰበሰበበት ቀን",
  remarkPlaceholder: "ዝርዝር መረጃ ያቅርቡ...",
  evidenceFiles: "የማስረጃ ፋይሎች",
  fileTypesSimple: "PDF, JPG, PNG ፋይሎች",
  collectorNameRequired: "የሰብሳቢ ስም ያስፈልጋል",
  evidenceTypeRequired: "የማስረጃ ዓይነት ያስፈልጋል",
  collectionDateRequired: "የተሰበሰበበት ቀን ያስፈልጋል",
  evidenceSuccessfullyAdded: "ማስረጃው በተሳካ ሁኔታ ተጨምሯል",
  failedToSubmitEvidence: "ማስረጃ ማስገባት አልተሳካም",
  selectType: "ዓይነት ይምረጡ",
  documentary: "ሰነድ",
  digital: "ዲጂታል",
  physical: "አካላዊ",
  other: "ሌላ",
  addInitialHearingOnChargeDocument: "በክስ ሰነድ ላይ የመጀመሪያ ችሎት ያክሉ",
  councilDecision: "የምክር ቤት ውሳኔ",
  isCouncilDecideInitialDay: "ምክር ቤቱ የመጀመሪያ ቀን ወስኗል?",
  letterFileRequired: "የደብዳቤ ፋይል ያስፈልጋል",
  createLetter: "መጥሪያ ፍጠር",
  letterDocument: "የደብዳቤ ሰነድ",
  sendSummonToo: "መጥሪያም ይላክ?",
  addDailyHearingFeedback: "የቀን ችሎት አስተያየት ያክሉ",
  addReporter: "አመልካች ያክሉ",
  fullName: "ሙሉ ስም",
  fullNamePlaceholder: "ሙሉ ስም ያስገቡ",
  phonePlaceholder: "+251-XXX-XXXXXX",
  email: "ኢሜይል",
  emailPlaceholder: "email@example.com",
  address: "አድራሻ",
  addressPlaceholder: "የመንገድ አድራሻ",
  locationDetails: "የቦታ ዝርዝሮች",
  city: "ከተማ",
  idNumber: "የመታወቂያ ቁጥር",
  idCard: "መታወቂያ ካርድ",
  uploadIdCard: "መታወቂያ ካርድ ጫን",
  addSummonDecision: "የመጥሪያ ውሳኔ ያክሉ",
  summonLetterNotFound: "የመጥሪያ ደብዳቤ አልተገኘም!",
  uploadResponseFile: "እባክዎን የምላሽ ፋይል ይጫኑ",
  addVictim: "ተጎጂ ያክሉ",
  addWitness: "ምስክር ያክሉ",
  registeredRegistrationDate: "የተመዘገበበት ቀን",
  updateMemorandum: "ማስታወሻ አዘምን",
  latest: "የቅርብ ጊዜ",
  noChargeDocumentUploaded: "ምንም የክስ ሰነድ አልተጫነም",
  councilFeedback: "የምክር ቤት አስተያየት",
  latestVersion: "የቅርብ ጊዜ እትም",
  noSummaryAvailable: "ምንም ማጠቃለያ የለም",
  noArticleDetailsAvailable: "ምንም የአንቀጽ ዝርዝር መረጃ የለም",
  documentHistory: "የሰነድ ታሪክ",

  previousVersions: "ቀድሞ የነበሩ እትሞች",
  directorFeedback: "የዳይሬክተር አስተያየት",
  feedbacks: "አስተያየቶች",
  addDirectorFeedback: "የዳይሬክተር አስተያየት ያክሉ",
  successfullyForwardedToProsecutor: "በተሳካ ሁኔታ ወደ ዐቃቤ ሕግ ተላልፏል",
  forwardToProsecutor: "ወደ ዐቃቤ ሕግ አስተላልፍ",
  councilInitialDecision: "የምክር ቤቱ የመጀመሪያ ውሳኔ",
  initialDecision: "የመጀመሪያ ውሳኔ",
  decisionMadeOnInitialDay: "በመጀመሪያው ቀን የተሰጠ ውሳኔ",
  initialDayDecision: "የመጀመሪያ ቀን ውሳኔ",
  noDecision: "ውሳኔ አልተሰጠም",
  rejectCharge: "ክሱን ውድቅ አድርግ",
  chargeRejection: "የክስ ውድቅ መደረግ",
  councilRejectedCharge: "ምክር ቤቱ ክሱን ውድቅ አድርጓል",
  rejected: "ውድቅ የተደረገ",
  rejectionDate: "ውድቅ የተደረገበት ቀን",
  rejectionReason: "ውድቅ የተደረገበት ምክንያት",
  registerChargeDocument: "የክስ ሰነድ መዝግብ",
  caseStatus: "የመዝገቡ ሁኔታ",
  currentComplaintStatus: "የቅሬታው የአሁኑ ሁኔታ",
  accusedLicenseNo: "የተከሳሽ የፈቃድ ቁጥር",
  commissionOfDisciplinaryOffense: "የዲሲፕሊን ጥፋት አፈጻጸም",
  additionalInformation: "ተጨማሪ መረጃ",
  allComplaintDetailsDisplayed: "ሁሉም የቅሬታ ዝርዝሮች እዚህ ይታያሉ",
  terminationDocument: "የመዝገብ መዝጊያ ሰነድ",
  officialTerminationDocument: "ይፋዊ የመዝገብ መዝጊያ ሰነድ",
  decisionInformation: "የውሳኔ መረጃ",
  active: "ንቁ",
  latestDecision: "የቅርብ ጊዜ ውሳኔ",
  current: "የአሁኑ",
  outOfJurisdictionSource: "ከስልጣን ውጪ የሆነ ምንጭ",
  previousDecisions: "ቀደም ያሉ ውሳኔዎች",
  decision: "ውሳኔ",
  collapseAll: "ሁሉንም ሰብስብ",
  expandAll: "ሁሉንም ዘርጋ",
  noDecisionsMade: "እስካሁን ምንም ውሳኔ አልተሰጠም።",
  evidenceInformation: "የማስረጃ መረጃ",
  supportingEvidenceDocuments: "ደጋፊ የማስረጃ ሰነዶች",
  hearingTimeline: "የችሎት የጊዜ መስመር",
  chronologicalRecordOfHearings: "የሁሉም የችሎት ሂደቶች የቅደም-ተከተል መዝገብ",
  hearing: "ችሎት",
  hearings: "ችሎቶች",
  hearingSession: "የችሎት ክፍለ-ጊዜ",
  next: "ቀጣይ",
  order: "ትዕዛዝ",
  noCouncilLitigationData: "ምንም የምክር ቤት ክርክር መረጃ የለም",
  noCouncilLitigationMessage:
    "ለዚህ መዝገብ የሚገኝ ምንም የምክር ቤት ውሳኔ ወይም የችሎት መዝገብ የለም።",
  finalDecisionRenderedByCouncil: "በምክር ቤቱ የተሰጠ የመጨረሻ ውሳኔ",
  prosecutorDecisions: "የዐቃቤ ሕግ ውሳኔዎች",
  decisions: "ውሳኔዎች",
  notAssignedYet: "እስካሁን አልተመደበም",
  noSummaryProvided: "ምንም ማጠቃለያ አልተሰጠም",
  chargeDocuments: "የክስ ሰነዶች",
  noDecisionsYet: "እስካሁን ምንም ውሳኔ የለም",
  noProsecutorDecisionsMade: "ለዚህ መዝገብ የተሰጠ ምንም የዐቃቤ ሕግ ውሳኔ የለም",
  evidenceDetails: "የማስረጃ ዝርዝሮች",
  collectedDate: "የተሰበሰበበት ቀን",
  remarks: "ማስታወሻዎች",
  evidenceFile: "የማስረጃ ፋይል",
  noEvidenceAdded: "ምንም ማስረጃ አልተጨመረም",
  addEvidenceToCase: "ለመዝገቡ ማስረጃ ያክሉ",
  noEvidenceRegistered: "ለዚህ መዝገብ የተመዘገበ ምንም ማስረጃ የለም",
  unknownCollector: "ያልታወቀ ሰብሳቢ",
  noDescriptionProvided: "ምንም መግለጫ አልተሰጠም",
  evidenceDocuments: "የማስረጃ ሰነዶች",
  noReportersAdded: "ምንም አመልካቾች አልተጨመሩም",
  addReportersToCase: "ለመዝገቡ አመልካቾችን ያክሉ",
  noReportersRegistered: "ለዚህ መዝገብ የተመዘገበ ምንም አመልካች የለም",
  unnamedReporter: "ስሙ ያልተጠቀሰ አመልካች",
  idDocuments: "የመታወቂያ ሰነዶች",
  noVictimsAdded: "ምንም ተጎጂዎች አልተጨመሩም",
  addVictimsToCase: "ለመዝገቡ ተጎጂዎችን ያክሉ",
  noVictimsRegistered: "ለዚህ መዝገብ የተመዘገበ ምንም ተጎጂ የለም",
  unnamedVictim: "ስሙ ያልተጠቀሰ ተጎጂ",
  idDocument: "የመታወቂያ ሰነድ",
  noWitnessesAdded: "ምንም ምስክሮች አልተጨመሩም",
  addWitnessesToCase: "ለመዝገቡ ምስክሮችን ያክሉ",
  noWitnessesRegistered: "ለዚህ መዝገብ የተመዘገበ ምንም ምስክር የለም",
  unnamedWitness: "ስሙ ያልተጠቀሰ ምስክር",
  witnessDocuments: "የምስክር ሰነዶች",
  overdue: "ቀኑ ያለፈበት",
  upcoming: "የሚመጣ",
  scheduled: "ቀጠሮ የተያዘለት",
  nextAppointment: "የሚቀጥለው ቀጠሮ",
  prosecutor: "ዐቃቤ ሕግ",
  appealDaysRemaining: "ለይግባኝ የቀሩ ቀናት",
  rejectChargeDocument: "የክስ ሰነዱን ውድቅ አድርግ",
  comment: "አስተያየት",
  emailAddress: "የኢሜይል አድራሻ",
  completeAddress: "ሙሉ አድራሻ",
  regionState: "ክልል",
  cityTown: "ከተማ",
  close: "ዝጋ",
  reporterFile: "የአመልካች ፋይል",
  reporterInformationRecord: "የአመልካች መረጃ መዝገብ",
  reporterDetails: "የአመልካች ዝርዝር መረጃ",
  notProvided: "አልተሰጠም",
  reporterLocation: "የአመልካች አድራሻ",
  identificationDocuments: "የመለያ ሰነዶች",
  reporterIdDocument: "የአመልካች መታወቂያ ሰነድ",
  pdfDocument: "የፒዲኤፍ ሰነድ",
  uploaded: "ተጭኗል",
  recorded: "ተመዝግቧል",
  lastUpdated: "ለመጨረሻ ጊዜ የተሻሻለው",
  reporterRecord: "የአመልካች መዝገብ",
  officialRecord: "ይፋዊ መዝገብ",
  closeFile: "ፋይሉን ዝጋ",
  hearingDatePassed: "የችሎቱ ቀን አልፏል",
  hearingIsToday: "ችሎቱ ዛሬ ነው",
  daysRemaining: "{days} ቀናት ይቀራሉ",
  hearingSummon: "የችሎት መጥሪያ",
  summonSummary: "የመጥሪያ ማጠቃለያ",
  officialLetter: "ይፋዊ ደብዳቤ",
  summonDocument: "የመጥሪያ ሰነድ",
  confirmSummon: "መጥሪያውን አረጋግጥ",
  officialDocuments: "ይፋዊ ሰነዶች",
  responseLettersAndCorrespondence: "የምላሽ ደብዳቤዎች እና ግንኙነቶች",
  accusedAdvocateResponse: "የተከሳሽ ጠበቃ ምላሽ",
  officialResponseSubmission: "ይፋዊ የምላሽ ማስገቢያ",
  officialSummonLetter: "ይፋዊ የመጥሪያ ደብዳቤ",
  governmentIssuedSummon: "በመንግስት የተሰጠ የመጥሪያ ደብዳቤ",
  submitAccusedAdvocateResponse: "የተከሳሽ ጠበቃ ምላሽን አስገባ",
  summonConfirmationStatus: "የመጥሪያ ማረጋገጫ ሁኔታ",
  overallStatus: "አጠቃላይ ሁኔታ",
  fullyConfirmed: "ሙሉ በሙሉ የተረጋገጠ",
  partiallyConfirmed: "በከፊል የተረጋገጠ",
  prosecutorReassignedSuccessfully: "ዐቃቤ ሕግ በተሳካ ሁኔታ እንደገና ተመድቧል",
  failedToReassignProsecutor: "ዐቃቤ ሕግን እንደገና መመደብ አልተሳካም",
  currentAssignment: "የአሁኑ ምደባ",
  currentlyAssignedProsecutor: "በአሁኑ ጊዜ የተመደበ ዐቃቤ ሕግ",
  noProsecutorAssigned: "የተመደበ ዐቃቤ ሕግ የለም",
  pleaseAssignProsecutor: "እባክዎን ለዚህ መዝገብ ዐቃቤ ሕግ መድቡ",
  assignNewProsecutor: "አዲስ ዐቃቤ ሕግ መድብ",
  required: "አስገዳጅ",
  searchProsecutorsPlaceholder: "ዐቃቤ ሕግን በስም ይፈልጉ...",
  advocateDisciplineProsecutor: "የጠበቆች ዲሲፕሊን ዐቃቤ ሕግ",
  selectFromList: "ከዝርዝሩ ውስጥ ይምረጡ",
  chooseProsecutor: "ዐቃቤ ሕግ ይምረጡ...",
  selectedProsecutor: "የተመረጠ ዐቃቤ ሕግ",
  newAssignment: "አዲስ ምደባ",
  willReplace: "ይተካል",
  theCurrentAssignment: "የአሁኑን ምደባ",
  note: "ማስታወሻ",
  reassignProsecutorNote: "ይህ ለዚህ መዝገብ ኃላፊነት ያለበትን ዐቃቤ ሕግ እንደገና ይመድባል።",
  reassigning: "እንደገና በመመደብ ላይ...",
  confirmSubmissionTitle: "ማስገባቱን ያረጋግጡ",
  confirmSubmissionMessage:
    "እባክዎን ያስገቡትን መረጃ በጥንቃቄ ይገምግሙ። አንዴ ከተረጋገጠ ድርጊቱ ይፈጸማል እና ሊለወጥ አይችልም።",
  search: "ፈልግ",
  noDataAvailable: "ምንም የሚገኝ መረጃ የለም።",
  rowsPerPage: "በአንድ ገጽ የሚታዩ ተርታዎች፡",
  of: "ከ",
  page: "ገጽ",
  first: "መጀመሪያ",
  prev: "ቀዳሚ",
  last: "መጨረሻ",
  attachment: "አባሪ",
  thisFieldIsRequired: "ይህ ቦታ መሞላት አለበት",
  removeSelectedFile: "የተመረጠውን ፋይል አስወግድ",
  uploadAFileHere: "ፋይል እዚህ ይጫኑ",
  downloadFile: "ፋይል አውርድ",
  view: "እይ",
  cannotConstructFileUrl: "የፋይል ዩአርኤል (URL) መፍጠር አልተቻለም",
  failedToInitializeDocument: "ሰነዱን ማስጀመር አልተሳካም",
  emptyFileReceived: "ባዶ ፋይል ደርሷል",
  unknownError: "ያልታወቀ ስህተት",
  failedToLoadPdf: "ፒዲኤፍ መጫን አልተሳካም",
  noFileUrlAvailableForDownload: "ለማውረድ የሚገኝ የፋይል ዩአርኤል የለም",
  failedToDownloadFile: "ፋይሉን ማውረድ አልተሳካም",
  unknownDocument: "ያልታወቀ ሰነድ",
  minute: "ደቂቃ",
  loadingPdf: "ፒዲኤፍ በመጫን ላይ...",
  pdfCouldNotBeLoaded: "ፒዲኤፍ መጫን አልተቻለም",
  openInNewTab: "በአዲስ ታብ ክፈት",
  downloadPdf: "ፒዲኤፍ አውርድ",
  pdfLoadedSuccessfully: "ፒዲኤፍ በተሳካ ሁኔታ ተጭኗል",
  noFileUrl: "የፋይል ዩአርኤል የለም",
  failedToLoadImage: "ምስል መጫን አልተሳካም",
  file: "ፋይል",
  unavailable: "አይገኝም",
  download: "አውርድ",
  created: "ተፈጥሯል",
  loadingDocument: "ሰነድ በመጫን ላይ...",
  errorLoadingDocument: "ሰነድ በመጫን ላይ ስህተት ተከስቷል",
  tryDownloadAnyway: "ቢሆንም ለማውረድ ሞክር",
  failedToLoadVideo: "ቪዲዮ መጫን አልተሳካም",
  browserDoesNotSupportVideo: "የእርስዎ ብሮውዘር ቪዲዮውን አይደግፍም።",
  failedToLoadAudio: "ኦዲዮ መጫን አልተሳካም",
  browserDoesNotSupportAudio: "የእርስዎ ብሮውዘር ኦዲዮውን አይደግፍም።",
  fileCannotBePreviewed: "ይህ ፋይል በብሮውዘሩ ውስጥ ሊታይ አይችልም። እባክዎን ለማየት ፋይሉን ያውርዱ።",
  closeModal: "ዝጋ",
  updated: "ተሻሽሏል",
  type: "ዓይነት",
  notifications: "ማሳወቂያዎች",
  unread: "ያልተነበበ",
  noNewNotifications: "አዲስ ማሳወቂያ የለም",
  noNotifications: "ምንም ማሳወቂያ የለም",
  new: "አዲስ",
  newNotification: "አዲስ ማሳወቂያ",
  showing: "በማሳየት ላይ",
  menuDashboardSection: "ዳሽቦርድ",
  menuDashboard: "ዳሽቦርድ",
  menuMainTask: "ዋና ተግባር",
  menuReports: "ሪፖርቶች",
  menuProsecutor: "ዐቃቤ ሕግ",
  menuComplaint: "ቅሬታ",
  menuAppealedComplaint: "ይግባኝ የቀረበበት ቅሬታ",
  menuAccusedAppeal: "የተከሳሽ ይግባኝ",
  menuCourtAppeal: "የፍርድ ቤት ይግባኝ",
  loadingMenus: "ሜኑዎች በመጫን ላይ...",
  menuAdvocate: "ጠበቃ",
  menuCompliant: "ቅሬታ አቅራቢ",
  menuAppealedCompliant: "ይግባኝ አቅራቢ",
  menuDiscipline: "ዲሲፕሊን",
  menuReportByMobile: "ሪፖርት በሞባይል",
  poweredByEaii: "በ EAII የተደገፈ",
  logout: "ውጣ",
  brandOfficeName: "Biiroo Abba Alangaa W.O.",
  brandOfficeNameAm: "የኦሮሚያ ጠቅላይ ዐቃቤ ሕግ ቢሮ",
  uploadClaimFile: "የክስ ፋይል ጫን",
  upload: "ጫን",
  updateChargeDocument: "የክስ ሰነድ አዘምን",
  update: "አዘምን",
  victimFile: "የተጎጂ ፋይል",
  victimInformationRecord: "የተጎጂ መረጃ መዝገብ",
  victimDetails: "የተጎጂ ዝርዝሮች",
  victimLocation: "የተጎጂ አድራሻ",
  victimIdDocument: "የተጎጂ መታወቂያ ሰነድ",
  victimRecord: "የተጎጂ መዝገብ",
  witnessStatementFile: "የምስክር ቃል ፋይል",
  witnessInformationRecord: "የምስክር መረጃ መዝገብ",
  witnessDetails: "የምስክር ዝርዝሮች",
  witnessLocation: "የምስክር አድራሻ",
  witnessIdDocument: "የምስክር መታወቂያ ሰነድ",
  statementRecorded: "ቃል ተመዝግቧል",
  witnessStatement: "የምስክር ቃል",
  advocateCourtAppealRequests: "የጠበቃ የፍርድ ቤት ይግባኝ ጥያቄዎች",
  courtAppealDetail: "የፍርድ ቤት ይግባኝ ዝርዝር",
  courtSummonNotFound: "የፍርድ ቤት መጥሪያ አልተገኘም!",
  addCourtAppealDailyHearing: "የፍርድ ቤት ይግባኝ የቀን ችሎት ያክሉ",
  reportType: "የሪፖርት ዓይነት",
  isItFinalDecision: "የመጨረሻ ውሳኔ ነው?",
  successful: "ተሳክቷል",
  courtAppealSummon: "የፍርድ ቤት ይግባኝ መጥሪያ",
  appealDocuments: "የይግባኝ ሰነዶች",
  noAppealDocumentsUploaded: "ምንም የይግባኝ ሰነዶች አልተጫኑም",
  courtDetails: "የፍርድ ቤት ዝርዝሮች",
  courtHearingDate: "የፍርድ ቤት ችሎት ቀን",
  courtOrder: "የፍርድ ቤት ትዕዛዝ",
  sendToCoordinator: "ወደ አስተባባሪ ላክ",
  confirmCourtSummon: "የፍርድ ቤት መጥሪያን አረጋግጥ",
  disciplineManagement: "የዲሲፕሊን አስተዳደር",
  baawoSystem: "የB.A.A.W.O. ስርዓት",
  loginTitle: "ግባ",
  authFormInstruction: "የእለት ተእለት ተግባርዎን ለመጀመር እባክዎን ይህንን ቅጽ በጥንቃቄ ይሙሉ",
  emailLabel: "ኢሜይል",
  passwordLabel: "የይለፍ ቃል",
  passwordPlaceholder: "የይለፍ ቃልዎን ያስገቡ",
  newPasswordLabel: "አዲስ የይለፍ ቃል",
  newPasswordPlaceholder: "አዲስ የይለፍ ቃል ያስገቡ",
  confirmPasswordLabel: "የይለፍ ቃል አረጋግጥ",
  confirmPasswordPlaceholder: "የይለፍ ቃልዎን ያስገቡ",
  registerAccountTitle: "መለያ ይመዝግቡ",
  loading: "በመጫን ላይ...",
  loginButton: "ግባ",
  registerButton: "መዝግብ",
  invalidEmailOrPassword: "የተሳሳተ ኢሜይል ወይም የይለፍ ቃል",
  loginOfficeName: "የሕዝብ ዐቃቤ ሕግ ቢሮ",
  loginOfficeAddress: "የአድራሻ መረጃ",
  dontHaveAccount: "መለያ የለዎትም?",
  alreadyHaveAccount: "መለያ አለዎት?",
  incidentListTitle: "የክስተቶች ዝርዝር",
  incidentCaseColumn: "መዝገብ",
  incidentTypeColumn: "ዓይነት",
  incidentStatusColumn: "ሁኔታ",
  incidentDateColumn: "ቀን",
  incidentTypeRobbery: "ዝርፊያ",
  incidentTypeFraud: "ማጭበርበር",
  incidentTypeAssault: "ጥቃት",
  incidentInformationTab: "የክስተት መረጃ",
  evidenceFilesTab: "የማስረጃ ፋይሎች",
  suspectTab: "ተጠርጣሪ",
  victimsTab: "ተጎጂዎች",
  witnessesTab: "ምስክሮች",
  exhibitsTab: "ኤግዚቢቶች",
  screeningTab: "ምርመራ",
  incidentDetailsInformationTitle: "የክስተት ዝርዝር መረጃ",
  incidentDetailsPlaceholder: "ዝርዝር መረጃ እዚህ ይገለጻል...",
  incidentReportDate: "ክስተቱ ሪፖርት የተደረገበት ቀን",
  incidentDate: "ክስተቱ የተፈጸመበት ቀን",
  crimeCategoryLabel: "የወንጀል ምድብ",
  receptionMethodLabel: "የአቀባበል ዘዴ",
  regionLabel: "ክልል",
  addressLabel: "አድራሻ",
  incidentReportedBy: "ክስተቱ ሪፖርት የተደረገው በ",
  reporterAgeEducationCountry: "54 ዓመት • ዲግሪ • ኢትዮጵያዊ",
  crimeNarrativeInfo: "የወንጀል ታሪክ መረጃ",
  evidenceOne: "አንደኛ ማስረጃ",
  evidenceTwo: "ሁለተኛ ማስረጃ",
  crimeInformationTitle: "የወንጀል መረጃ",
  suspectsListLabel: "የተጠርጣሪዎች ዝርዝር",
  suspectsListDesc: "2 ግለሰቦች • ለመጨረሻ ጊዜ የተሻሻለበት ቀን",
  victimListLabel: "የተጎጂዎች ዝርዝር",
  victimListDesc: "2 ተጎጂዎች • ሁለቱም • ለመጨረሻ ጊዜ የተሻሻለበት ቀን",
  evidenceListLabel: "የማስረጃ ዝርዝር",
  evidenceListDesc: "3 እቃዎች • ፒዲኤፍ • ለመጨረሻ ጊዜ የተሻሻለው",
  exhibitItemsListLabel: "የኤግዚቢት እቃዎች ዝርዝር",
  exhibitItemsListDesc: "2 እቃዎች • የዶክመንት ፋይሎች • ለመጨረሻ ጊዜ የተሻሻለው",
  respondBackButton: "ምላሽ ስጥ",
  approveButton: "አጽድቅ",
  dashboardOverviewTitle: "አጠቃላይ እይታ",
  dashboardOverviewDescription:
    "በዐቃቤ ሕግ የሥራ ሂደት ውስጥ ያሉ ንቁ ስራዎችን ይቆጣጠሩ፣ አስቸኳይ ጉዳዮችን ይለዩ እና ዋና ዋና የመዝገብ አስተዳደር ስራዎችን በአንድ ቦታ ይከታተሉኝ።",
  dashboardActiveScopes: "ንቁ ስራዎች",
  dashboardPriorityQueues: "ቅድሚያ የሚሰጣቸው ጉዳዮች",
  dashboardUpcomingMilestones: "የሚመጡ ዋና ዋና ኩነቶች",
  dashboardOperationalSnapshot: "የስራ ክንውን ቅኝት",
  dashboardPriorityQueuesTitle: "ቅድሚያ የሚሰጣቸው ጉዳዮች",
  dashboardPriorityQueuesDescription:
    "ለአስተባባሪዎች፣ ለሬጅስትራሮች እና ለዐቃቤ ሕጎች አፋጣኝ ትኩረት የሚሹ ቦታዎች።",
  dashboardStatusCritical: "አስቸኳይ",
  dashboardStatusAttention: "ትኩረት የሚሻ",
  dashboardStatusStable: "የተረጋጋ",
  dashboardProjectScopeCoverage: "የፕሮጀክት ስራዎች ሽፋን",
  dashboardWorkloadAcrossModules: "በዋና ዋና የዐቃቤ ሕግ ክፍሎች ውስጥ ያለው የሥራ ጫና",
  dashboardScopes: "ስራዎች",
  dashboardTotal: "ጠቅላላ",
  dashboardInProgress: "በሂደት ላይ",
  dashboardOpenModule: "ክፍሉን ክፈት",
  complainantName: "የቅሬታ አቅራቢ ስም",
  complainantPhone: "የቅሬታ አቅራቢ ስልክ",
  accusedProsecutorName: "የተከሳሽ ዐቃቤ ሕግ ስም",
  disciplineReportByMobile: "የዲሲፕሊን ሪፖርት በሞባይል",
  disciplineReportTable: "← የዲሲፕሊን ሪፖርት ሰንጠረዥ",
  courtAppealRequests: "የፍርድ ቤት ይግባኝ ጥያቄዎች",
  registerCouncilAttendanceTitle: "የከሳሽ እና የተከሳሽ ዐቃቤ ሕግ መገኘት መመዝገቢያ",
  namePlaceholder: "ስም እዚህ...",
  appealRequests: "የይግባኝ ጥያቄዎች",
  updateDate: "የተሻሻለበት ቀን",
  addEvaluation: "ምዘና ያክሉ",
  evaluationDate: "የምዘና ቀን",
  viewEvaluation: "ምዘናውን እይ",
  submitAccusedResponse: "ይፋዊ ምላሽ አስገባ",

  evaluation: "ምዘና",
  workSpeedEvaluation: "የሥራ ፍጥነት ምዘና",
  workQualityEvaluation: "የሥራ ጥራት ምዘና",
  workLoadEvaluation: "የሥራ ጫና ምዘና",
  noEvaluationsFound: "ምንም ምዘና አልተገኘም",

  reload: "እንደገና ጫን",
  // Prosecutor discipline dashboard
  pdDashboardTitle: "ዳሽቦርድ",
  pdWelcomeBack: "እንኳን ደህና መጡ",
  pdOverviewAssigned: "ለእርስዎ የተመደቡ የዲሲፕሊን ጉዳዮች አጠቃላይ እይታ።",
  pdOverviewUnit: "በአስተዳደር ክፍልዎ ያሉ የዐቃቤ ሕግ ዲሲፕሊን ጉዳዮች አጠቃላይ እይታ።",
  pdOverviewAll: "ሊያዩዋቸው የሚችሉ የዐቃቤ ሕግ ዲሲፕሊን ጉዳዮች አጠቃላይ እይታ።",
  pdScopeAll: "ሁሉም የአስተዳደር ክፍሎች",
  pdScopeAssigned: "የተመደቡልኝ ጉዳዮች",
  pdScopeUnit: "የአስተዳደር ክፍል",
  pdRangeAll: "ሁሉም ጊዜ",
  pdRange7: "ያለፉት 7 ቀናት",
  pdRange30: "ያለፉት 30 ቀናት",
  pdRange90: "ያለፉት 90 ቀናት",
  pdRangeYear: "ይህ ዓመት",
  pdRangeCustom: "የተመረጠ ጊዜ",
  pdFrom: "ከ",
  pdTo: "እስከ",
  pdRefresh: "አድስ",
  pdLoading: "በመጫን ላይ...",
  pdTotalCases: "ጠቅላላ ጉዳዮች",
  pdTotalCasesHint: "በዚህ ጊዜ ውስጥ ያሉ ሁሉም ጉዳዮች",
  pdFromPrevious: "ከቀደመው ጊዜ",
  pdOfTotal: "ከጠቅላላ ጉዳዮች",
  pdYourQueue: "የእርስዎ ወረፋ",
  pdStageReceived: "የተቀበሉ",
  pdStageReceivedHint: "አዲስ፣ የተመለሱ ወይም መረጃ የሚጠብቁ",
  pdStageInvestigation: "በምርመራ ላይ",
  pdStageInvestigationHint: "የተመደቡ፣ በምርመራ ወይም ክስ በማዘጋጀት ላይ",
  pdStageCouncil: "በጉባኤ ላይ",
  pdStageCouncilHint: "መጥሪያ፣ ፓናል፣ ክርክር እና ውሳኔ",
  pdStageAppeal: "ይግባኝ የተባሉ",
  pdStageClosed: "የተዘጉ",
  pdStageClosedHint: "የተዘጉ፣ የተጠናቀቁ፣ የተቋረጡ ወይም ውድቅ የተደረጉ",
  pdStageOther: "ሌሎች",
  pdSummons: "የወጡ መጥሪያዎች",
  pdCasesByStage: "ጉዳዮች በደረጃ",
  pdCaseTrend: "የጉዳዮች አዝማሚያ",
  pdLast6Months: "(ያለፉት 6 ወራት)",
  pdByOffence: "ጉዳዮች በጥፋት ዓይነት",
  pdByDecision: "ውሳኔዎች",
  pdUpcomingHearings: "መጪ ችሎቶች (30 ቀናት)",
  pdRecentCases: "የቅርብ ጊዜ ጉዳዮች",
  pdViewAll: "ሁሉንም ይመልከቱ",
  pdNoData: "ለዚህ ጊዜ መረጃ የለም",
  pdNoHearings: "በሚቀጥሉት 30 ቀናት ችሎት የለም",
  pdNoRoleDashboard: "ለእርስዎ ሚና የዐቃቤ ሕግ ዲሲፕሊን ዳሽቦርድ የለም።",
  pdLoadFailed: "የዳሽቦርድ መረጃ መጫን አልተቻለም",
};

export default am;
